module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/add_medical_leaders/logo03-e5e63d186fb2342edb918683abaef521.svg";